export const LOGIN = "LOGIN";
export const CLEAR_USER = "CLEAR_USER";
